
import React, { JSX } from 'react'

export const YOUTUBE_COUNT_DISCLOSURE =
  'Counts calculated by StagePilot from public live chat messages. Not supplied by YouTube.'

const DISCLOSURE_FONT_PX = 11

const DISCLOSURE_STYLE: React.CSSProperties = {
  fontSize: DISCLOSURE_FONT_PX,
  lineHeight: 1.35,
  textAlign: 'center',
  color: 'rgba(255,255,255,0.85)',
  textShadow: '0 1px 2px rgba(0,0,0,0.9)',
  marginTop: 6,
  fontFamily: 'inherit'
}

export const YouTubeDisclosureLine = (): JSX.Element => (
  <div style={DISCLOSURE_STYLE} data-testid='youtube-count-disclosure'>
    {YOUTUBE_COUNT_DISCLOSURE}
  </div>
)
